import React, { createContext, useContext, useState, useCallback } from 'react';
import api from '../utils/api';

const VisitorContext = createContext();

export function VisitorProvider({ children }) {
  const [visitor, setVisitor] = useState(() => {
    try {
      const saved = localStorage.getItem('gglancc_visitor');
      return saved ? JSON.parse(saved) : null;
    } catch { return null; }
  });

  const [showLogin, setShowLogin] = useState(false);

  const loginWithGoogle = useCallback(async (credential) => {
    try {
      const res = await api.post('/visitor/google-login', { credential });
      const v = res.data.visitor;
      setVisitor(v);
      localStorage.setItem('gglancc_visitor', JSON.stringify(v));
      setShowLogin(false);
      return v;
    } catch (err) {
      console.error('Google login failed:', err);
      return null;
    }
  }, []);

  const logout = useCallback(() => {
    setVisitor(null);
    localStorage.removeItem('gglancc_visitor');
  }, []);

  const promptLogin = useCallback(() => setShowLogin(true), []);
  const dismissLogin = useCallback(() => {
    setShowLogin(false);
    // Don't show again for 24 hours
    localStorage.setItem('gglancc_login_dismissed', Date.now().toString());
  }, []);

  return (
    <VisitorContext.Provider value={{ visitor, loginWithGoogle, logout, showLogin, promptLogin, dismissLogin }}>
      {children}
    </VisitorContext.Provider>
  );
}

export function useVisitor() {
  return useContext(VisitorContext);
}
